module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-drawer', {
    attrs: {
      "right": "",
      "open": _vm.open
    }
  }, _vm._l((_vm.tipsList), function(item, index) {
    return _c('div', {
      staticClass: "tips-content",
      on: {
        "click": function($event) {
          _vm.continueTrain(item.uuid)
        }
      }
    }, [_c('div', {
      staticClass: "tips-text"
    }, [_vm._v("您有一个正在进行中的训练")]), _vm._v(" "), _c('div', {
      staticClass: "tips-name"
    }, [_vm._v("患者：" + _vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "tips-surplus"
    }, [_vm._v("剩余时间：" + _vm._s(_vm._f("timer")(item.left)))]), _vm._v(" "), _c('em', {
      staticClass: "tips-right"
    }, [_vm._v(">")])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-059e194b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timer/trainTips.vue
// module id = 940
// module chunks = 2